import { useSelector } from 'react-redux';

function FreeTrialHeader() {
  const userDetails = useSelector((state) => state.userReducer);
  const { remainingTrialPeriod } = userDetails.subscription;

  return (
    <div className="topmost bg-dark p-2 fixed-top text-center text-white">
      <span className="text-danger">{Math.round(remainingTrialPeriod)}</span>{' '}
      days left of your free trial.{' '}
      <a href="/settings/billing/" className="btn btn-sm btn-primary">
        Upgrade plan
      </a>
    </div>
  );
}

export default FreeTrialHeader;
